import Navigation from "../../components/Navigation";
// import Footer from "../../components/Footer";
import { Helmet } from "react-helmet-async";
import "./style.css";
import { Phone, Mail } from "lucide-react";

const Contact = () => {
	return (
		<>
			<Navigation />
			<Helmet>
				<title>Jean Tax & Legal Practitioners | Contact</title>
				<meta name="description" content="Contact Jean Tax & Legal Practitioners for tax, legal, and compliance consultations. Phone and email available." />
				<meta name="keywords" content="contact tax advice, legal advice, consultations, SARS help, South Africa" />
				<link rel="canonical" href="https://jeantaxandlegal.co.za/contact" />
				<meta property="og:title" content="Jean Tax & Legal Practitioners | Contact" />
				<meta property="og:description" content="Reach out to Jean Tax & Legal for reliable tax and legal support." />
				<meta property="og:type" content="website" />
				<meta property="og:url" content="https://jeantaxandlegal.co.za/contact" />
			</Helmet>
			<main className="contact">
				<section className="contact-hero">
					<h1>Contact Us</h1>
					<p>Book your consultation or ask a question.</p>
				</section>

				<section className="contact-form-section">

				{/* Replace the old <form> with this section */}
				<div className="cd-section-wrapper">
				<div className="cd-links-container">
					{/* 📞 Phone */}
					<a href="tel:+27123456789" className="cd-anchor">
					<Phone size={18} className="cd-icon" />
					<span className="cd-label"> Phone: </span>
					<span className="cd-value">+27 63 492 2628</span>
					</a>
					<br />

					{/* 📞 Phone 2 */}
					{/* <a href="tel:+27123456789" className="cd-anchor">
					<Phone size={18} className="cd-icon" />
					<span className="cd-label"> Phone: </span>
					<span className="cd-value">+27 67 621 8734</span>
					</a>
					<br /> */}
					{/* <span className="contact-separator">|</span> */}

					{/* 📧 Email */}
					<a href="mailto:info@jeantaxandlegal.co.za" className="cd-anchor">
					<Mail size={18} className="cd-icon" />
					<span className="cd-label"> Email: </span>
					<span className="cd-value">info@jeantaxandlegal.co.za</span>
					</a>
				</div>
				</div>
					{/* <form className="contact-form">
						<label>Name</label>
						<input type="text" placeholder="Your Name" required />

						<label>Email</label>
						<input type="email" placeholder="Your Email" required />

						<label>Message</label>
						<textarea placeholder="Your Message" required></textarea>

						<button type="submit" className="btn">Send Message</button>
					</form> */}
				</section>
			</main>
			{/* <Footer /> */}
		</>
	);
};

export default Contact;